import {
  useLazyGetSivConfrimationLetterQuery,
  useLazySelectSivConfrimationLetterQuery,
  usePublishSivConfrimationLetterMutation,
  useUpdateSivConfrimationLetterMutation,
  useCreateNewVersionMutation
} from 'src/services/SIVConfirmationLetter';

export const useSIVConfirmationLetter = () => {
  const [
    getSivConfrimationLetter,
    {
      data: sivConfrimationLetterData,
      isLoading: sivConfrimationLetterIsLoading,
      isError: sivConfrimationLetterIsError,
      error: sivConfrimationLetterError,
      isSuccess: sivConfrimationLetterIsSuccess
    }
  ] = useLazyGetSivConfrimationLetterQuery();

  const [
    selectSivConfrimationLetter,
    {
      data: selectSivConfrimationLetterData,
      isLoading: selectSivConfrimationLetterIsLoading,
      isError: selectSivConfrimationLetterIsError,
      error: selectSivConfrimationLetterError,
      isSuccess: selectSivConfrimationLetterIsSuccess
    }
  ] = useLazySelectSivConfrimationLetterQuery();

  const [
    updateSivConfrimationLetter,
    {
      data: updateSivConfrimationLetterData,
      isLoading: updateSivConfrimationLetterIsLoading,
      isError: updateSivConfrimationLetterIsError,
      error: updateSivConfrimationLetterError,
      isSuccess: updateSivConfrimationLetterIsSuccess
    }
  ] = useUpdateSivConfrimationLetterMutation();

  const [
    publishSivConfrimationLetter,
    {
      data: publishSivConfrimationLetterData,
      isLoading: publishSivConfrimationLetterIsLoading,
      isError: publishSivConfrimationLetterIsError,
      error: publishSivConfrimationLetterError,
      isSuccess: publishSivConfrimationLetterIsSuccess
    }
  ] = usePublishSivConfrimationLetterMutation();
  const [
    createNewVersion,
    {
      data: createNewVersionData,
      isLoading: createNewVersionIsLoading,
      isError: createNewVersionIsError,
      error: createNewVersionError,
      isSuccess: createNewVersionIsSuccess
    }
  ] = useCreateNewVersionMutation();

  return {
    getSivConfrimationLetter,
    sivConfrimationLetterData,
    sivConfrimationLetterIsLoading,
    sivConfrimationLetterIsError,
    sivConfrimationLetterError,
    sivConfrimationLetterIsSuccess,
    selectSivConfrimationLetter,
    selectSivConfrimationLetterData,
    selectSivConfrimationLetterIsLoading,
    selectSivConfrimationLetterIsError,
    selectSivConfrimationLetterError,
    selectSivConfrimationLetterIsSuccess,
    updateSivConfrimationLetter,
    updateSivConfrimationLetterData,
    updateSivConfrimationLetterIsLoading,
    updateSivConfrimationLetterIsError,
    updateSivConfrimationLetterError,
    updateSivConfrimationLetterIsSuccess,
    publishSivConfrimationLetter,
    publishSivConfrimationLetterData,
    publishSivConfrimationLetterIsLoading,
    publishSivConfrimationLetterIsError,
    publishSivConfrimationLetterError,
    publishSivConfrimationLetterIsSuccess,
    createNewVersion,
    createNewVersionData,
    createNewVersionIsLoading,
    createNewVersionIsError,
    createNewVersionError,
    createNewVersionIsSuccess
  };
};
